import { PlannerProductComponent, ProductInfoComponent, ShoppingBagComponent, DoorOpeningDirectionComponent, PartKey, ProductType, getProductReferenceFor, isOfType, InteriorComponent, OuterMeasurementsComponent, getProduct, ProductDesign, HideFromAssemblyInstructionsComponent, SlidingDoorComponent, OrganizerComponent, MatchesColorsComponent, MetalInteriorComponent, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent, AngledEntityComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, AllowedDoorPairsComponent, AutoAdaptGuestComponent, HierarchyUtils } from '@inter-ikea-core/core';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import CustomizedSlidingDoorComponent from '../components/CustomizedSlidingDoorComponent';
import CornerAddonFrameComponent from '../components/CornerAddonFrameComponent';
import DontAllowPlacementOnCornerAddonFrameComponent from '../components/DontAllowPlacementOnCornerAddonFrameComponent';
import CornerRegularFrameComponent from '../components/CornerRegularFrameComponent';
import DontAllowPlacementOnCornerRegularFrameComponent from '../components/DontAllowPlacementOnCornerRegularFrameComponent';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
import NonDuplicatableComponent from '@inter-ikea-storageone/range/src/core-api/components/NonDuplicatableComponent';
const spaceEnabled = new URLSearchParams(window.location.search).get('enableSpacePlanning') === 'true';
export const paxComponentResolver = (coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts, isMobile) => {
    // Should include all product types that should be added to the price/shoppinglist
    const isShoppingProduct = isOfType([
        ProductType.PAX_FRAME,
        ProductType.PAX_HINGE_DOOR,
        ProductType.PAX_SOFT_CLOSING_HINGE,
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_PANEL_FRAME,
        ProductType.PAX_SLIDING_DOOR_PANEL,
        ProductType.PAX_SOFT_CLOSING_DEVICE_SLIDING_DOORS,
        ProductType.PAX_SOFT_OPENING_CLOSING_DEVICE_SLIDING_DOORS,
        ProductType.PAX_SHELF,
        ProductType.PAX_MESH_BASKET,
        ProductType.PAX_METAL_BASKET,
        ProductType.PAX_MESH_BASKET_RAIL,
        ProductType.PAX_PULL_OUT_TROUSER_HANGER,
        ProductType.PAX_CLOTH_RAIL_350,
        ProductType.PAX_CLOTH_RAIL_580,
        ProductType.PAX_GLASS_SHELF,
        ProductType.PAX_DRAWER,
        ProductType.PAX_PULL_OUT_TRAY,
        ProductType.PAX_PULL_OUT_TRAY_INSERT,
        ProductType.PAX_DIVIDER_FOR_PULL_OUT_TRAY,
        ProductType.PAX_SHOE_INSERT_FOR_PULL_OUT_TRAY,
        ProductType.PAX_INSERT_WITH_4_COMP,
        ProductType.PAX_INSERT_FOR_JEWELLERY,
        ProductType.PAX_DRAWER_MAT,
        ProductType.PAX_DRAWER_BOX,
        ProductType.PAX_GLASS_DRAWER,
        ProductType.PAX_PULL_OUT_SHOE_SHELF,
        ProductType.PAX_PULL_OUT_CLOTH_RAIL,
        ProductType.PAX_PULL_OUT_STORAGE_BAG,
        ProductType.PAX_DRAWER_FRAMED_GLASS,
        ProductType.PAX_DRAWER_FRAMED,
        ProductType.PAX_DRAWER_LOCKABLE,
        ProductType.PAX_SHOE_SHELF,
        ProductType.PAX_VALET_HANGER,
        ProductType.PAX_T_DIVIDER,
        ProductType.PAX_L_DIVIDER,
        ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.HANDLE_DRILL_TEMPLATE,
        ProductType.PAX_ADD_ON_CORNER_FRAME_ASM,
        ProductType.PAX_CORNER_HINGE,
        ProductType.PAX_INNER_LIGHT,
        ProductType.PAX_INNER_LIGHT_OVERSIDAN,
        ProductType.PAX_OUTER_LIGHT,
        ProductType.LIGHT_CORD,
        ProductType.LIGHT_DRIVER,
        ProductType.LIGHT_CONTROLER,
        ProductType.PAX_SKUBB_STORAGE_CASES,
        ProductType.PAX_SKUBB_SHOE_BOXES,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
        ProductType.PAX_SKUBB_STORAGE_BOXES,
        ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
        ProductType.PAX_SKUBB_HANGING_STORAGE,
        ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
        ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
        ProductType.PAX_COVER_CAPS,
        ProductType.CLOTH_HANGERS,
        ProductType.PAX_SHOE_MAT,
        ProductType.PAX_CLEANING_INTERIOR
    ]);
    //Should include all product types that should added to the scene
    const isPlannerProduct = isOfType([
        ProductType.PAX_FRAME,
        ProductType.PAX_HINGE_DOOR_ASM,
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM,
        ProductType.PAX_SHELF,
        ProductType.PAX_MESH_BASKET_ASM,
        ProductType.PAX_METAL_BASKET_ASM,
        ProductType.PAX_PULL_OUT_TROUSER_HANGER,
        ProductType.PAX_CLOTH_RAIL_350,
        ProductType.PAX_CLOTH_RAIL_580,
        ProductType.PAX_GLASS_SHELF,
        ProductType.PAX_DRAWER,
        ProductType.PAX_DRAWER_MAT,
        ProductType.PAX_DRAWER_BOX_ASM,
        ProductType.PAX_PULL_OUT_TRAY,
        ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM,
        ProductType.PAX_GLASS_DRAWER,
        ProductType.PAX_PULL_OUT_SHOE_SHELF,
        ProductType.PAX_PULL_OUT_CLOTH_RAIL,
        ProductType.PAX_PULL_OUT_STORAGE_BAG,
        ProductType.PAX_DRAWER_FRAMED_GLASS,
        ProductType.PAX_DRAWER_FRAMED,
        ProductType.PAX_DRAWER_LOCKABLE,
        ProductType.PAX_SHOE_SHELF,
        ProductType.PAX_VALET_HANGER,
        ProductType.PAX_T_DIVIDER,
        ProductType.PAX_L_DIVIDER,
        ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.PAX_CORNER_SOLUTION_ASM,
        ProductType.PAX_INNER_LIGHT,
        ProductType.PAX_INNER_LIGHT_OVERSIDAN,
        ProductType.PAX_OUTER_LIGHT,
        ProductType.LIGHT_CORD,
        ProductType.LIGHT_DRIVER,
        ProductType.LIGHT_CONTROLER,
        ProductType.PAX_SKUBB_STORAGE_CASES,
        ProductType.PAX_SKUBB_SHOE_BOXES,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
        ProductType.PAX_SKUBB_STORAGE_BOXES,
        ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
        ProductType.PAX_SKUBB_HANGING_STORAGE,
        ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
        ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
        ProductType.PAX_SHOE_MAT,
        ProductType.PAX_CLEANING_INTERIOR,
        ProductType.PAX_COVER_CAPS,
        ProductType.HANDLE_DRILL_TEMPLATE
    ]);
    const isInterior = isOfType([
        ProductType.PAX_SHELF,
        ProductType.PAX_GLASS_SHELF,
        ProductType.PAX_CLOTH_RAIL_350,
        ProductType.PAX_CLOTH_RAIL_580,
        ProductType.PAX_PULL_OUT_TROUSER_HANGER,
        ProductType.PAX_PULL_OUT_TRAY,
        ProductType.PAX_PULL_OUT_CLOTH_RAIL,
        ProductType.PAX_DRAWER,
        ProductType.PAX_GLASS_DRAWER,
        ProductType.PAX_PULL_OUT_SHOE_SHELF,
        ProductType.PAX_PULL_OUT_STORAGE_BAG,
        ProductType.PAX_DRAWER_FRAMED_GLASS,
        ProductType.PAX_DRAWER_FRAMED,
        ProductType.PAX_DRAWER_LOCKABLE,
        ProductType.PAX_SHOE_SHELF,
        ProductType.PAX_VALET_HANGER,
        ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
        ProductType.PAX_MESH_BASKET_ASM,
        ProductType.PAX_METAL_BASKET_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
        ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM,
        ProductType.PAX_T_DIVIDER,
        ProductType.PAX_L_DIVIDER,
        ProductType.PAX_CLEANING_INTERIOR
    ]);
    const isDoor = isOfType([
        ProductType.PAX_HINGE_DOOR_ASM,
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
    ]);
    const shouldBeRemovedFromAssemblyImages = isOfType([
        ProductType.PAX_HINGE_DOOR_ASM,
        ProductType.PAX_HINGE_DOOR,
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM,
        ProductType.PAX_SKUBB_STORAGE_CASES,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
        ProductType.PAX_SKUBB_SHOE_BOXES,
        ProductType.PAX_SKUBB_STORAGE_BOXES,
        ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
        ProductType.PAX_SKUBB_HANGING_STORAGE,
        ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
        ProductType.PAX_SKUBB_STORAGE_CASE_WRAP
    ]);
    const isSlidingDoor = isOfType([
        ProductType.PAX_SLIDING_DOOR_REGULAR_ASM,
        ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.PAX_FRAME,
        ProductType.PAX_HINGE_DOOR,
        ProductType.PAX_SLIDING_DOOR_REGULAR_FRONT,
        ProductType.PAX_SLIDING_DOOR_PANEL_FRONT,
        ProductType.PAX_VALET_HANGER,
        ProductType.PAX_OUTER_LIGHT,
        ProductType.PAX_ADD_ON_CORNER_FRAME,
        ProductType.PAX_CORNER_MEASUREMENT_FRAME
    ]);
    const isOrganizer = isOfType([
        ProductType.PAX_SKUBB_SHOE_BOXES,
        ProductType.PAX_SKUBB_STORAGE_CASES,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
        ProductType.PAX_SKUBB_STORAGE_BOXES,
        ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
        ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
        ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
        ProductType.PAX_SKUBB_HANGING_STORAGE,
        ProductType.PAX_DRAWER_BOX_ASM,
        ProductType.PAX_DRAWER_MAT,
        ProductType.PAX_SHOE_MAT
    ]);
    const isMetalInterior = isOfType([
        ProductType.PAX_CLOTH_RAIL_580,
        ProductType.PAX_PULL_OUT_MULTI_USE_HANGER,
        ProductType.PAX_MESH_BASKET_ASM,
        ProductType.PAX_METAL_BASKET_ASM,
        ProductType.PAX_SHOE_SHELF,
        ProductType.PAX_PULL_OUT_SHOE_SHELF,
        ProductType.PAX_VALET_HANGER,
        ProductType.PAX_CLEANING_INTERIOR
    ]);
    const isNonDuplicatable = isOfType([
        ProductType.PAX_CORNER_SOLUTION_ASM,
        ProductType.PAX_OUTER_LIGHT,
        ProductType.PAX_INNER_LIGHT,
        ProductType.PAX_INNER_LIGHT_OVERSIDAN
    ]);
    const isValetHanger = (entity) => isOfType([ProductType.PAX_VALET_HANGER])(entity);
    const isCornerSolution = (entity) => isOfType([ProductType.PAX_CORNER_SOLUTION_ASM])(entity);
    const isCornerAddonFrame = (entity) => isOfType([ProductType.PAX_ADD_ON_CORNER_FRAME])(entity);
    const isCornerRegularFrame = (entity) => coreApi.entities.hasPartKey(entity, PartKey.CORNER_SOLUTION_NORMAL_FRAME);
    const getClothRailAutoAdaptVariants = (clothRail, products) => {
        const clotheRails = products.filter(p => p.type === ProductType.PAX_CLOTH_RAIL_350 || p.type === ProductType.PAX_CLOTH_RAIL_580);
        const type = clothRail.getComponent(ProductInfoComponent.id)?.productType;
        const design = clothRail.getComponent(ProductInfoComponent.id)?.design;
        const variantsOfSameDepth = clotheRails
            .filter(p => p.type === type && p.design === design)
            .map(product => product.coreProductId);
        const designIsLight = design === ProductDesign.WHITE || design === ProductDesign.WHITE_STAINED_OAK;
        const isProductLight = (p) => p.design === ProductDesign.WHITE || p.design === ProductDesign.WHITE_STAINED_OAK;
        const isProductDark = (p) => p.design === ProductDesign.DARK_GREY ||
            p.design === ProductDesign.DARK_GREY_METAL ||
            p.design === ProductDesign.BLACK_BROWN;
        const variantsOfDifferentDepth = type === ProductType.PAX_CLOTH_RAIL_350
            ? clotheRails
                .filter(product => product.type === ProductType.PAX_CLOTH_RAIL_580)
                .filter(product => {
                return designIsLight ? isProductLight(product) : isProductDark(product);
            })
                .map(product => product.coreProductId)
            : clotheRails
                .filter(product => product.type === ProductType.PAX_CLOTH_RAIL_350)
                .filter(product => {
                return designIsLight ? isProductLight(product) : isProductDark(product);
            })
                .map(product => product.coreProductId);
        return [...variantsOfSameDepth, ...variantsOfDifferentDepth];
    };
    const addAllowedDoorPairsComponent = (entity) => {
        if (isOfType([ProductType.PAX_ADD_ON_CORNER_FRAME])(entity)) {
            entity.addComponent(new AllowedDoorPairsComponent([[500]]));
        }
        else {
            const comSize = entity.getComponentUnsafe(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID);
            const width = comSize.size.width;
            switch (width) {
                case 1000:
                    entity.addComponent(new AllowedDoorPairsComponent([[500, 500]]));
                    break;
                case 750:
                    entity.addComponent(new AllowedDoorPairsComponent([
                        [250, 500],
                        [375, 375]
                    ]));
                    break;
                case 500:
                    entity.addComponent(new AllowedDoorPairsComponent([[250, 250], [500]]));
                    break;
                default:
                    throw Error('Trying to add AllowedDoorPairsComponent to frame with unsupported width!');
            }
        }
    };
    const ignoredProductPartKeys = [
        PartKey.CORNER_SOLUTION_NORMAL_FRAME,
        PartKey.TRAY,
        PartKey.MAT
    ];
    const shouldExcludeProduct = (entity) => {
        if (entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID) &&
            ignoredProductPartKeys.includes(entity.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID).partKey)) {
            return true;
        }
        return false;
    };
    const isPullOutTray = (entity, product) => {
        const productType = product?.type;
        return productType
            ? [
                ProductType.PAX_PULL_OUT_TRAY,
                ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
                ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
                ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
                ProductType.PAX_PULL_OUT_TRAY_INSERT
            ].includes(productType)
            : false;
    };
    const shouldNotBeSelectable = (entity) => {
        return (coreApi.entities.isOneOfProductTypes(entity, [ProductType.HANDLE, ProductType.KNOB]) ||
            (isMobile &&
                coreApi.entities.isOneOfProductTypes(entity, [
                    ProductType.PAX_OUTER_LIGHT,
                    ProductType.PAX_INNER_LIGHT,
                    ProductType.PAX_INNER_LIGHT_OVERSIDAN,
                    ProductType.PAX_DRAWER_BOX_ASM,
                    ProductType.PAX_DRAWER_MAT,
                    ProductType.PAX_SKUBB_STORAGE_CASES,
                    ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
                    ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
                    ProductType.PAX_SKUBB_SHOE_BOXES,
                    ProductType.PAX_SKUBB_STORAGE_BOXES,
                    ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
                    ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
                    ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
                    ProductType.PAX_SKUBB_HANGING_STORAGE
                ])));
    };
    const shouldNotBeDraggable = (entity) => {
        return isDoor(entity);
    };
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                entity.addComponent(new AssemblyInstructionsComponent());
                entity.addComponent(new HideInSeeThroughSystemComponent());
                if (!isCornerAddonFrame(entity) && !isCornerRegularFrame(entity)) {
                    entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.LEFT, Direction.RIGHT], [], true));
                }
            }
            if (isCornerSolution(entity)) {
                entity.addComponent(new CornerSolutionComponent());
                entity.addComponent(new AngledEntityComponent());
                if (!spaceEnabled) {
                    const part = HierarchyUtils.descendants(entity).find(e => {
                        return coreApi.entities.getProductType(e) === ProductType.PAX_CORNER_MEASUREMENT_FRAME;
                    });
                    if (part)
                        coreApi.entities.delete(part);
                }
            }
            if (isCornerRegularFrame(entity)) {
                entity.addComponent(new CornerRegularFrameComponent());
            }
            if (isCornerAddonFrame(entity)) {
                entity.addComponent(new CornerAddonFrameComponent());
            }
            if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                addAllowedDoorPairsComponent(entity);
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (shouldNotBeSelectable(entity)) {
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (shouldNotBeDraggable(entity)) {
                entity.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
            }
            if (isDoor(entity)) {
                if (isSlidingDoor(entity)) {
                    entity.addComponent(new SlidingDoorComponent());
                }
                if (product?.meta?.allowOnCornerRegularFrame !== undefined &&
                    product?.meta.allowOnCornerRegularFrame === false) {
                    entity.addComponent(new DontAllowPlacementOnCornerRegularFrameComponent());
                }
                if (product?.meta?.allowOnCornerAddonFrame !== undefined &&
                    product?.meta.allowOnCornerAddonFrame === false) {
                    entity.addComponent(new DontAllowPlacementOnCornerAddonFrameComponent());
                }
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
                if (!isValetHanger(entity)) {
                    entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
                }
            }
            if (isOrganizer(entity)) {
                entity.addComponent(new OrganizerComponent());
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
            if (isMetalInterior(entity)) {
                entity.addComponent(new MetalInteriorComponent());
            }
            if (coreApi.entities.isOneOfProductTypes(entity, [
                ProductType.PAX_CLOTH_RAIL_350,
                ProductType.PAX_CLOTH_RAIL_580
            ])) {
                const variants = getClothRailAutoAdaptVariants(entity, products);
                entity.addComponent(new AutoAdaptGuestComponent(variants));
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (isPlannerProduct(entity) && !shouldExcludeProduct(entity)) {
                if (!entity.hasComponent(CustomizedSlidingDoorComponent.id)) {
                    entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
                }
                if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
                    entity.addComponent(new DoorOpeningDirectionComponent());
                }
                if (isPullOutTray(entity, product)) {
                    const drawerMat = coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_DRAWER_MAT);
                    drawerMat && drawerMat.removeComponent(ComponentIds.DRAGGABLE_COMPONENT_ID);
                    drawerMat && drawerMat.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
                }
            }
            if (product?.meta?.matchesColors) {
                entity.addComponent(new MatchesColorsComponent(product.meta.matchesColors));
            }
            if (isNonDuplicatable(entity)) {
                entity.addComponent(new NonDuplicatableComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=paxComponentResolver.js.map